<template>
  <div class="main-wrapper">
    <layout-header />
    <layout-sidebar />

    <div class="page-wrapper" ref="formContainer">
      <div class="content container-fluid">
        <inbox-header :title="title" :path="path" :text="text" />

        <div class="row filter-row">
          <div class="col-sm-6 col-md-3">
            <div class="input-block mb-3 form-focus focused">
              <vue-select
                :options="employeeList"
                id="employeeList"
                placeholder="-"
                v-model="employeeId"
              />
              <label class="focus-label">Employee Name</label>
            </div>
          </div>

          <div class="col-sm-6 col-md-3">
            <div class="input-block mb-3 form-focus focused">
              <div class="cal-icon">
                <datepicker
                  v-model="startDate"
                  placeholder="-"
                  class="form-control floating datetimepicker"
                  :editable="true"
                  :clearable="false"
                  :input-format="dateFormat"
                />
                <label class="focus-label">Start Date</label>
              </div>
            </div>
          </div>

          <div class="col-sm-6 col-md-3">
            <div class="input-block mb-3 form-focus focused">
              <div class="cal-icon">
                <datepicker
                  v-model="endDate"
                  placeholder="-"
                  class="form-control floating datetimepicker"
                  :editable="true"
                  :clearable="false"
                  :input-format="dateFormat"
                />
                <label class="focus-label">End Date</label>
              </div>
            </div>
          </div>

          <div class="col-sm-6 col-md-3">
            <a
              href="javascript:;"
              class="btn btn-success w-100 submit-btn mb-3"
              @click="searchLogs()"
            >
              Search
            </a>
            <a
              href="javascript:;"
              class="btn btn-danger w-100 submit-btn"
              @click="searchLogs(true)"
            >
              Clear
            </a>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="showentries mb-3">
              <label>
                Show
                <select v-model="pagination.pageSize" @change="updatePerPage">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                entries
              </label>
            </div>

            <div class="table-responsive">
              <a-table
                class="stripped table-hover"
                :columns="columns"
                :data-source="data"
                :pagination="pagination"
                :row-key="(record) => record.key || record.id || record.index"
                @change="handleTableChange"
              >
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'employee_id'">
                    {{
                      record.employee_id ??
                      record.user_id ??
                      (record.employee && record.employee.id) ??
                      (record.user && record.user.id) ??
                      "—"
                    }}
                  </template>
                  <template v-else-if="column.key === 'employee_name'">
                    {{ record.employee_name || "—" }}
                  </template>
                  <template v-else-if="column.key === 'role'">
                    {{
                      record.role ??
                      (record.employee &&
                        record.employee.roles &&
                        record.employee.roles[0] &&
                        record.employee.roles[0].name) ??
                      (record.user &&
                        record.user.roles &&
                        record.user.roles[0] &&
                        record.user.roles[0].name) ??
                      "—"
                    }}
                  </template>
                  <template v-else-if="column.key === 'prompt_message'">
                    {{
                      record.prompt_message ??
                      record.prompt ??
                      record.message ??
                      "—"
                    }}
                  </template>
                  <template v-else-if="column.key === 'date'">
                    {{
                      record.date ||
                      record.created_at ||
                      record.log_time ||
                      record.logged_at ||
                      record.date_time
                    }}
                  </template>
                  <template v-else-if="column.key === 'action'">
                    {{
                      record.action ||
                      record.activity ||
                      record.type ||
                      record.punch_type ||
                      "—"
                    }}
                  </template>
                </template>
              </a-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { notification } from "ant-design-vue";
import axios from "axios";
import dayjs from "dayjs";

var pagination = { total: 0, current: 1, pageSize: 10 };

const columns = [
  {
    title: "Sr No.",
    key: "index",
    dataIndex: "index",
    customRender: ({ index }) => {
      return pagination.current === 1
        ? index + 1
        : (pagination.current - 1) * pagination.pageSize + (index + 1);
    },
  },
  {
    title: "Employee ID",
    key: "employee_id",
    dataIndex: "employee_id",
  },
  {
    title: "Employee",
    key: "employee_name",
    dataIndex: "employee_name",
  },
  {
    title: "Role",
    key: "role",
    dataIndex: "role",
  },
  {
    title: "Prompt Message",
    key: "prompt_message",
    dataIndex: "prompt_message",
  },
  {
    title: "Date (Date/Time)",
    key: "date",
    dataIndex: "date",
  },
  {
    title: "Action",
    key: "action",
    dataIndex: "action",
  },
];

export default {
  data() {
    return {
      title: "Kiosk Activity Logs",
      path: "Activity Logs",
      text: "Kiosk Activity Logs",
      data: [],
      columns,
      pagination,
      employeeList: [],
      employeeId: "",
      startDate: "",
      endDate: "",
      dateFormat: "dd-MM-yyyy",
    };
  },
  mounted() {
    const params = {
      params: { per_page: this.pagination.pageSize },
    };
    this.fetchKioskLogs(params);
    this.loadAllEmployee();
  },
  methods: {
    getFirst(row, ...paths) {
      for (const p of paths) {
        if (p == null || p === "") continue;
        if (typeof p !== "string") {
          if (p != null && p !== "") return p;
          continue;
        }
        const parts = p.split(".");
        let v = row;
        for (const part of parts) {
          v = v?.[part];
          if (v === undefined) break;
        }
        if (v !== undefined && v !== null && v !== "") return v;
      }
      return null;
    },
    normalizeRecord(row, index) {
      const emp = row?.employee || row?.user || row?.user_id || {};
      const firstName = emp?.first_name ?? row?.first_name ?? "";
      const lastName = emp?.last_name ?? row?.last_name ?? "";
      const employeeName =
        firstName || lastName
          ? `${firstName} ${lastName}`.trim()
          : row?.employee_name ?? row?.user_name ?? row?.name ?? "—";

      const date = this.getFirst(
        row,
        "date",
        "date_time",
        "created_at",
        "updated_at",
        "log_time",
        "timestamp",
        "logged_at",
        "activity_date",
        "log_date",
        "punch_in_time",
        "punch_out_time",
        "clock_in_at",
        "clock_out_at",
        "time",
        "logged_date",
        "created_date",
      );

      const action = this.getFirst(
        row,
        "action",
        "activity",
        "event",
        "type",
        "activity_type",
        "event_type",
        "log_type",
        "punch_type",
        "description",
        "message",
        "activity_name",
        "event_name",
        "action_type",
        "log_action",
      );

      const employeeId =
        row?.employee_id ?? row?.user_id ?? emp?.id ?? emp?.employee_id ?? null;

      let role =
        this.getFirst(row, "role", "role_name") ??
        emp?.roles?.[0]?.name ??
        emp?.role?.name ??
        row?.role?.name ??
        null;
      if (role && typeof role === "object" && role.name) role = role.name;

      const promptMessage = this.getFirst(
        row,
        "prompt_message",
        "prompt",
        "message",
        "prompt_msg",
        "display_message",
      );

      const actionStr =
        typeof action === "string"
          ? action
          : action != null
          ? String(action)
          : "—";
      const roleStr =
        typeof role === "string" ? role : role != null ? String(role) : "—";
      const promptStr =
        typeof promptMessage === "string"
          ? promptMessage
          : promptMessage != null
          ? String(promptMessage)
          : "—";

      return {
        ...row,
        key: row?.id ?? row?.key ?? `row-${index}`,
        id: row?.id ?? row?.key ?? index,
        employee_id: employeeId,
        employee_name: employeeName,
        role: roleStr,
        prompt_message: promptStr,
        date: date ?? "",
        action: actionStr,
      };
    },
    formatDate(date) {
      if (!date) return "—";
      return dayjs(date).isValid()
        ? dayjs(date).format("DD MMM YYYY, hh:mm A")
        : date;
    },
    searchLogs(isClear = false) {
      if (isClear) {
        this.employeeId = "";
        this.startDate = "";
        this.endDate = "";
      }

      let filters = {
        per_page: this.pagination.pageSize,
      };

      if (this.employeeId)
        filters.employee_id = this.employeeId?.id || this.employeeId;
      if (this.startDate)
        filters.start_date = dayjs(this.startDate).format("YYYY-MM-DD");
      if (this.endDate)
        filters.end_date = dayjs(this.endDate).format("YYYY-MM-DD");
      if (filters.start_date && !filters.end_date)
        filters.date = filters.start_date;

      const params = { params: filters };
      this.fetchKioskLogs(params);
    },
    fetchKioskLogs(params) {
      var token = window.localStorage.getItem("token");
      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .get("/kiosk-activity-logs", params)
        .then((response) => {
          const res = response?.data || {};
          let list = [];
          let total = 0;
          let currentPage = 1;
          let perPage = this.pagination.pageSize;

          if (res.data && res.data.data && Array.isArray(res.data.data)) {
            list = res.data.data;
            total = res.data.total != null ? res.data.total : list.length;
            currentPage =
              res.data.current_page != null ? res.data.current_page : 1;
            perPage = res.data.per_page != null ? res.data.per_page : perPage;
          } else if (res.data && Array.isArray(res.data)) {
            list = res.data;
            total = list.length;
            currentPage = 1;
          } else if (Array.isArray(res)) {
            list = res;
            total = list.length;
            currentPage = 1;
          } else if (
            res.data &&
            typeof res.data === "object" &&
            !Array.isArray(res.data)
          ) {
            list =
              res.data.data ||
              res.data.logs ||
              res.data.kiosk_logs ||
              res.data.records ||
              [];
            if (!Array.isArray(list)) list = [];
            total = res.data.total != null ? res.data.total : list.length;
            currentPage =
              res.data.current_page != null ? res.data.current_page : 1;
            perPage = res.data.per_page != null ? res.data.per_page : perPage;
          }

          this.pagination.total = total;
          this.pagination.current = currentPage;
          this.pagination.pageSize = perPage;
          this.data = list.map((row, idx) => this.normalizeRecord(row, idx));
          loader.hide();
        })
        .catch((error) => {
          loader.hide();

          var response = error.response;
          if (
            error.response?.status == 401 &&
            response?.data?.message == "Unauthenticated."
          ) {
            localStorage.clear();
            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: { background: process.env.VUE_APP_WARNING_COLOR },
            });
            this.$router.push({ name: "login" }).catch(() => {});
          } else {
            notification.open({
              message: response?.data?.message || error.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: { background: process.env.VUE_APP_WARNING_COLOR },
            });
          }
        });
    },
    handleTableChange(pagesize) {
      let filters = {
        per_page: pagesize.pageSize,
        page: pagesize.current,
      };

      if (this.employeeId)
        filters.employee_id = this.employeeId?.id || this.employeeId;
      if (this.startDate)
        filters.start_date = dayjs(this.startDate).format("YYYY-MM-DD");
      if (this.endDate)
        filters.end_date = dayjs(this.endDate).format("YYYY-MM-DD");
      if (filters.start_date && !filters.end_date)
        filters.date = filters.start_date;

      const params = { params: filters };
      this.fetchKioskLogs(params);
    },
    updatePerPage() {
      let filters = { per_page: this.pagination.pageSize };
      if (this.employeeId)
        filters.employee_id = this.employeeId?.id || this.employeeId;
      if (this.startDate)
        filters.start_date = dayjs(this.startDate).format("YYYY-MM-DD");
      if (this.endDate)
        filters.end_date = dayjs(this.endDate).format("YYYY-MM-DD");
      if (filters.start_date && !filters.end_date)
        filters.date = filters.start_date;
      this.fetchKioskLogs({ params: filters });
    },
    loadAllEmployee(params = null) {
      var token = window.localStorage.getItem("token");
      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      axios
        .get("/employees/all", params)
        .then((response) => {
          this.employeeList = [];
          if (response?.data?.data && Array.isArray(response.data.data)) {
            for (let i = 0; i < response.data.data.length; i++) {
              this.employeeList.push({
                id: response.data.data[i].id,
                text:
                  response.data.data[i].first_name +
                  " " +
                  response.data.data[i].last_name,
              });
            }
          }
        })
        .catch((error) => {
          var response = error.response;
          if (
            error.response?.status == 401 &&
            response?.data?.message == "Unauthenticated."
          ) {
            localStorage.clear();
            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: { background: process.env.VUE_APP_WARNING_COLOR },
            });
            this.$router.push({ name: "login" }).catch(() => {});
          } else {
            notification.open({
              message: response?.data?.message || error.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: { background: process.env.VUE_APP_WARNING_COLOR },
            });
          }
        });
    },
  },
};
</script>
